import { render, staticRenderFns } from "./ResourceRolesAndExceptions.vue?vue&type=template&id=ea905714&scoped=true&"
import script from "./ResourceRolesAndExceptions.vue?vue&type=script&lang=ts&"
export * from "./ResourceRolesAndExceptions.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceRolesAndExceptions.vue?vue&type=style&index=0&id=ea905714&scoped=true&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ea905714",
  null
  
)

export default component.exports